import React from "react";
import "regenerator-runtime/runtime";
import { appAxiosInstance } from "./app/getAxiosInstance.ts";
import ReactDOM from "react-dom/client";
import {
  MsalProvider,
  MsalAuthenticationTemplate,
} from "@azure/msal-react";
import { InteractionType, RedirectRequest } from "@azure/msal-browser";
import { msalInstance } from "./app/auth/authService.ts";
import { loginRequest } from "./app/auth/authConfig.ts";
import App from "./App.tsx";
import "./index.css";
import "./styles/react-aria.css";
import "./styles/common.css";
import { DarkModeProvider } from "./context/DarkModeContext";
import { CommonProvider } from "./context/CommonContext.tsx";
import { Provider } from "react-redux";
import { store } from "./app/store.ts";

msalInstance.initialize().then(() => {
  const authRequest: RedirectRequest = {
    scopes: loginRequest.scopes,
  };

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <MsalProvider instance={msalInstance}>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={authRequest}
      >
        <DarkModeProvider>
          <CommonProvider>
            <Provider store={store}>
              <App />
            </Provider>
          </CommonProvider>
        </DarkModeProvider>
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
});
